import {Component, Input, OnDestroy, OnInit} from '@angular/core';
import {Toast} from '../../services/toast/toast.model';
import {ToastService} from '../../services/toast/toast.service';

@Component({
    selector: 'tvcore-toast',
    templateUrl: './toast.component.html',
    styleUrls: ['./toast.component.scss'],
    standalone: false
})
export class ToastComponent implements OnInit, OnDestroy {
	@Input()
	toast: Toast;

	constructor(private toastService: ToastService) {}

	ngOnInit() {
		document.body.classList.add('has-toast');
	}

	clearToast() {
		this.toastService.clearToast();
	}

	getMessage(): string {
		if (this.toast) {
			const m = this.toast.message;

			if (typeof m === 'object') {
				return `Error: ${JSON.stringify(m)}`;
			}

			return m;
		}

		return '';
	}

	ngOnDestroy() {
		document.body.classList.remove('has-toast');
	}
}
